// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`render 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiGrid-root MuiGrid-container"
      >
        
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <div
            class="MuiBox-root MuiBox-root-1"
          >
            <div
              class="MuiGrid-root MuiGrid-container MuiGrid-justify-xs-space-between"
            >
              <div
                class="MuiBox-root MuiBox-root-2"
              >
                <span
                  class="MuiTypography-root MuiTypography-body2"
                >
                  My Facility
                </span>
              </div>
              <div
                class="MuiBox-root MuiBox-root-3"
                style="cursor: pointer;"
              >
                <svg
                  aria-hidden="true"
                  class="MuiSvgIcon-root"
                  focusable="false"
                  style="color: rgb(16, 128, 128);"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                  />
                </svg>
                <div
                  class="MuiBox-root MuiBox-root-4"
                >
                  <span
                    class="MuiTypography-root MuiTypography-body2"
                  >
                    Add New
                  </span>
                </div>
              </div>
            </div>
            <div
              class="MuiBox-root MuiBox-root-5"
            >
              <span
                class="MuiTypography-root MuiTypography-body1"
              >
                Create a facility for every office that’s registered with MSP for BCP / LFP. You’ll be able to select these facilities in a claim and also set a facility as your default facility.
              </span>
            </div>
            <div
              class="MuiBox-root MuiBox-root-6"
            >
              <div
                class="MuiBox-root MuiBox-root-7"
              >
                <div
                  class="MuiGrid-root MuiGrid-container MuiGrid-justify-xs-space-between"
                >
                  <div
                    class="MuiBox-root MuiBox-root-8"
                  >
                    <span
                      class="MuiTypography-root MuiTypography-body2"
                    >
                      First Facility
                      :
                       12345
                    </span>
                  </div>
                  <div
                    class="MuiBox-root MuiBox-root-9"
                    style="cursor: pointer;"
                  >
                    <svg
                      aria-hidden="true"
                      class="MuiSvgIcon-root"
                      focusable="false"
                      style="color: rgb(117, 117, 117);"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
                      />
                    </svg>
                    <div
                      class="MuiBox-root MuiBox-root-10"
                    >
                      <span
                        class="MuiTypography-root MuiTypography-body2"
                      >
                        Remove
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiGrid-root MuiGrid-container"
    >
      
      <div
        class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
      >
        <div
          class="MuiBox-root MuiBox-root-1"
        >
          <div
            class="MuiGrid-root MuiGrid-container MuiGrid-justify-xs-space-between"
          >
            <div
              class="MuiBox-root MuiBox-root-2"
            >
              <span
                class="MuiTypography-root MuiTypography-body2"
              >
                My Facility
              </span>
            </div>
            <div
              class="MuiBox-root MuiBox-root-3"
              style="cursor: pointer;"
            >
              <svg
                aria-hidden="true"
                class="MuiSvgIcon-root"
                focusable="false"
                style="color: rgb(16, 128, 128);"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                />
              </svg>
              <div
                class="MuiBox-root MuiBox-root-4"
              >
                <span
                  class="MuiTypography-root MuiTypography-body2"
                >
                  Add New
                </span>
              </div>
            </div>
          </div>
          <div
            class="MuiBox-root MuiBox-root-5"
          >
            <span
              class="MuiTypography-root MuiTypography-body1"
            >
              Create a facility for every office that’s registered with MSP for BCP / LFP. You’ll be able to select these facilities in a claim and also set a facility as your default facility.
            </span>
          </div>
          <div
            class="MuiBox-root MuiBox-root-6"
          >
            <div
              class="MuiBox-root MuiBox-root-7"
            >
              <div
                class="MuiGrid-root MuiGrid-container MuiGrid-justify-xs-space-between"
              >
                <div
                  class="MuiBox-root MuiBox-root-8"
                >
                  <span
                    class="MuiTypography-root MuiTypography-body2"
                  >
                    First Facility
                    :
                     12345
                  </span>
                </div>
                <div
                  class="MuiBox-root MuiBox-root-9"
                  style="cursor: pointer;"
                >
                  <svg
                    aria-hidden="true"
                    class="MuiSvgIcon-root"
                    focusable="false"
                    style="color: rgb(117, 117, 117);"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
                    />
                  </svg>
                  <div
                    class="MuiBox-root MuiBox-root-10"
                  >
                    <span
                      class="MuiTypography-root MuiTypography-body2"
                    >
                      Remove
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
